module.exports = __webpack_public_path__ + "static/img/brand-6.251d706.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/brand-6.png
// module id = xkZw
// module chunks = 0